import { FC } from 'react';

import cn from 'classnames';

import {
  formatMoney,
  getFormattedDuration,
  getPercent,
  formatDate,
} from '../../utils';
import { ReportProps } from '../index';
import s from './Header.module.scss';

export const Header: FC<ReportProps> = ({
  id,
  createdAt,
  finishedAt,
  workerFIO,
  card,
  cash,
  cashOnStart,
  deposit,
  onlineDeposit,
  bonus,
  inCashBox,
  clubName,
  currency,
  t,
  isDuplicate,
}) => {
  const proceeds = cash + card;

  return (
    <div className={s.container} id="report-header">
      <div className={s['club']}>
        {clubName}
        {isDuplicate && (
          <span className={s.duplicate}>
            {t('reports.workShift.print.duplicate')}
          </span>
        )}
        <span>{t('reports.workShift.print.number', id)}</span>
      </div>
      <div className={s.data}>
        <div className={s.row}>
          <div className={s.block}>
            <span className={s['secondary-text']}>{t('roles.operator')}</span>
            <span>{workerFIO}</span>
          </div>
          <div className={s.block}>
            <span className={s['secondary-text']}>{t('money.atStart')}</span>
            <span>{formatMoney(cashOnStart, currency)}</span>
          </div>
          <div className={cn(s.block)}>
            <span className={s['secondary-text']}>
              {t('reports.workShift.print.start')}
            </span>
            <span>{formatDate(createdAt)}</span>
          </div>
          <div className={s.block}>
            <span className={s['secondary-text']}>
              {t('reports.workShift.print.end')}
            </span>
            <span>{formatDate(finishedAt)}</span>
          </div>
          <div className={s.block}>
            <span className={s['secondary-text']}>
              {t('reports.workShift.print.duration')}
            </span>
            <span>{getFormattedDuration(t, createdAt, finishedAt)}</span>
          </div>
        </div>
        <div
          style={{
            width: '150%',
            height: 1,
            backgroundColor: 'black',
            marginLeft: -8,
          }}
        />
        <div className={s.row}>
          <div className={s.block}>
            <span className={s['secondary-text']}>{t('money.proceeds')}</span>
            <span>{formatMoney(proceeds, currency)}</span>
            <span className={s['secondary-text']}>
              {t('reports.workShift.print.proceeds.description')}
            </span>
          </div>
          <div className={s.block}>
            <span className={s['secondary-text']}>{t('money.cash')}</span>
            <span>{formatMoney(cash, currency)}</span>
            {cash > 0 && (
              <span className={s['secondary-text']}>
                {getPercent(cash, proceeds)}
              </span>
            )}
          </div>
          <div className={cn(s.block, s['border'])}>
            <span className={s['secondary-text']}>{t('money.card')}</span>
            <span>{formatMoney(card, currency)}</span>
            {card > 0 && (
              <span className={s['secondary-text']}>
                {getPercent(card, proceeds)}
              </span>
            )}
          </div>
          <div className={cn(s.block, s['border'])}>
            <span className={s['secondary-text']}>{t('money.inCashBox')}</span>
            <span>{formatMoney(inCashBox, currency)}</span>
            <span className={s['secondary-text']}>
              {t('reports.workShift.print.withOrders')}
            </span>
          </div>
          <div className={cn(s.block, s['border'])}>
            <div className={cn(s.block, s.block_padding)}>
              <span className={s['secondary-text']}>
                {t('category.deposits.spend')}
              </span>
              <span>{formatMoney(deposit, currency)}</span>
            </div>

            <div className={cn(s.block, s.block_padding)}>
              <span className={s['secondary-text']}>
                {t('category.online_deposit')}
              </span>
              <span>{formatMoney(onlineDeposit, currency)}</span>
            </div>
          </div>
          <div className={s['deposit']}>
            <div className={s.block}>
              <span className={s['secondary-text']}>{t('category.bonus')}</span>
              <span>{formatMoney(bonus, currency)}</span>
            </div>

            {/*<div className={s.block}>*/}
            {/*  <span className={s['secondary-text']}>*/}
            {/*    {t('category.deposits.spend')}*/}
            {/*  </span>*/}
            {/*  <span>{formatMoney(deposit, currency)}</span>*/}
            {/*</div>*/}
          </div>
        </div>
      </div>
    </div>
  );
};
